import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import ProductManager from "./Components/ProductManager";
import ProjectManager from "./Components/ProjectManager";
import NewsManager from "./Components/NewsManager";
import ContactManager from "./Components/ContactManager";
import UserManager from "./Components/UserManager";
import CommentManager from "./Components/CommentManager";
import { Helmet } from "react-helmet-async";
import { generateSitemap } from "../../assets/js/SitemapGenerator";
const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("san-pham");
 const [deferredPrompt, setDeferredPrompt] = useState(null); // Lưu sự kiện cài đặt
  const [showInstallBtn, setShowInstallBtn] = useState(false);
  useEffect(() => {
    // Bắt sự kiện cài đặt từ trình duyệt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallBtn(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    
    // Hiển thị hộp thoại cài đặt của trình duyệt
    deferredPrompt.prompt();
    
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      console.log("Người dùng đã cài đặt app");
    }
    setDeferredPrompt(null);
    setShowInstallBtn(false);
  };
  const username = "Admin"; 
  const navigate = useNavigate();

  // --- LOGIC HỖ TRỢ CÀI ĐẶT APP (PWA) ---
  useEffect(() => {
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e); // Lưu sự kiện để dùng cho nút bấm
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    return () => window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
  }, []);

  const handleInstallApp = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setDeferredPrompt(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/admin/login");
  };

  return (
    <div className="admin-layout">
      <Helmet>
        <title key="admin-dashboard">
          Trang quản lý 
        </title>
        
        </Helmet>
      {/* Sidebar */}
      <div className="sidebar">
        <div className="user-info">
          <div className="avatar">👤</div>
          <span>Chào, <b>{username}</b></span>
        </div>
        {showInstallBtn && (
          <button className="btn-pwa-install" onClick={handleInstallClick}>
            📲 Cài đặt App Quản lý
          </button>
        )}

        {/* Nút cài đặt App - Chỉ hiện nếu trình duyệt cho phép */}
        {deferredPrompt && (
          <button className="btn-install-pwa" onClick={handleInstallApp}>
            📲 Cài đặt App Admin
          </button>
        )}

        <nav className="menu">
          <button onClick={generateSitemap}>Xuất file Sitemap cho Google</button>
          <button className={activeTab === "san-pham" ? "active" : ""} onClick={() => setActiveTab("san-pham")}>📦 Sản phẩm</button>
          <button className={activeTab === "du-an" ? "active" : ""} onClick={() => setActiveTab("du-an")}>🏗️ Dự án</button>
          <button className={activeTab === "tin-tuc" ? "active" : ""} onClick={() => setActiveTab("tin-tuc")}>📰 Tin tức</button>
          <button className={activeTab === "lien-he" ? "active" : ""} onClick={() => setActiveTab("lien-he")}>📞 Liên hệ</button>
          <button className={activeTab === "nguoi-dung" ? "active" : ""} onClick={() => setActiveTab("nguoi-dung")}>👥 Người dùng</button>
          <button className={activeTab === "danh-gia" ? "active" : ""} onClick={() => setActiveTab("danh-gia")}>💬 Đánh giá</button>
        </nav>

        <button className="btn-logout" onClick={handleLogout}>Đăng xuất</button>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <header className="dashboard-header">
          <h2>{activeTab.toUpperCase().replace("-", " ")}</h2>
        </header>

        <div className="content-body">
          {activeTab === "san-pham" && <ProductManager />}
          {activeTab === "du-an" && <ProjectManager />}
          {activeTab === "tin-tuc" && <NewsManager />}
          {activeTab === "lien-he" && <ContactManager />}
          {activeTab === "nguoi-dung" && <UserManager />}
          {activeTab === "danh-gia" && <CommentManager />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;